import { render, staticRenderFns } from "./RemenLuxian.vue?vue&type=template&id=6c4c77d4&scoped=true&"
import script from "./RemenLuxian.vue?vue&type=script&lang=js&"
export * from "./RemenLuxian.vue?vue&type=script&lang=js&"
import style0 from "./RemenLuxian.vue?vue&type=style&index=0&id=6c4c77d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c77d4",
  null
  
)

export default component.exports